import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MARKETPLACE_STORE_KEY, MarketplaceState } from './marketplace.state';

export namespace MarketplaceSelectors {
  const selectMarketplaceFeature = createFeatureSelector<MarketplaceState>(MARKETPLACE_STORE_KEY);

  export const selectApplicationsWithProducts = createSelector(selectMarketplaceFeature, (state) => state.applicationsWithProducts);
}
